// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Holding as TokenStandardHolding } from '@daml.js/splice-api-token-holding/lib/Splice/Api/Token/HoldingV1';
import InterfaceContract from './InterfaceContract';

export const groupHoldings: (
  holdings: InterfaceContract<TokenStandardHolding>[],
) => Record<string, Record<string, InterfaceContract<TokenStandardHolding>[]>> = (holdings) => {
  return holdings.reduce(
    (acc, holding) => {
      const instrumentAdmin = holding.view(TokenStandardHolding).instrumentId.admin;
      const instrumentId = holding.view(TokenStandardHolding).instrumentId.id;

      if (!acc[instrumentAdmin]) {
        acc[instrumentAdmin] = {};
      }

      if (!acc[instrumentAdmin][instrumentId]) {
        acc[instrumentAdmin][instrumentId] = [];
      }

      acc[instrumentAdmin][instrumentId] = [...acc[instrumentAdmin][instrumentId], holding];

      return acc;
    },
    {} as Record<string, Record<string, InterfaceContract<TokenStandardHolding>[]>>,
  );
};
